<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>E-mail</th>
          <th>Criado por</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td class="text-center">{{ user.id }}</td>
          <td>{{ user.email }}</td>
          <td>
            {{ createdUpdatedUser(user.createdBy, user.createdAt) }}
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon"
              title="Excluir"
              @click="$emit('deleteUser', user.id)"
            >
              <i class="ph ph-trash" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { createdUpdatedUser } from '@/utils/strings'

export default {
  name: 'ListUsers',

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  emits: ['deleteUser'],

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListUsers',
        columnDefs: [
          {
            targets: [3],
            width: 80,
            orderable: false,
          },
        ],
      },
      createdUpdatedUser,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
